import { Component, Input, OnInit, Output, EventEmitter  } from '@angular/core';
import { AggregationRequest } from 'src/app/common-interfaces-classes/AggregationRequest';
import { TIAggRequest } from 'src/app/common-interfaces-classes/TIAggRequest';
import { GeneralConstants } from 'src/app/constants/GeneralConstants';
import { AggReqObjectHandlerService } from 'src/app/_services/agg-req-object-handler.service';
import { AggregationService } from 'src/app/_services/aggregation.service';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { FilterDataHandlerService } from 'src/app/_services/filter-data-handler.service';
import { GlobalService } from 'src/app/_services/global.service';
import { HashService } from 'src/app/_services/hash.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TalentInsightsReqHandlerService } from 'src/app/_services/talent-insights-req-handler.service';
import * as _ from "underscore";
declare const clevertap;


@Component({
    selector: 'app-webbtree-company-details',
    templateUrl: './webbtree-company-details.component.html',
    styleUrls: ['./webbtree-company-details.component.scss'],
    standalone: false
})
export class WebbtreeCompanyDetailsComponent implements OnInit {
  /**Get compny details from company list */
  @Input() companyDetails;
  // @Output() buttonClicked  = new EventEmitter<string>();
  @Output() buttonClicked = new EventEmitter<boolean>();
  alternatecompanyNames: string[] = [];
  medianTanuresCount: number;
  totalresultscount: number;
  hiresAndAttritionObj: any = {};
  companyName: string;
medianTenureLoader: boolean = false;
recentAttritionLoader: boolean = false;
recentHiresLoader: boolean = false;
  constructor(private aggReqObjectHandlerService: AggReqObjectHandlerService, private aggService: AggregationService, private companyInsightsService: CompanyInsightsService,
    private personSearchService: PersonSearchService, private filterDataHandlerService: FilterDataHandlerService, private talentInsightsReqHandlerService: TalentInsightsReqHandlerService,
    private localStorageService: LocalStorageService, private hashService: HashService
    ) { }

  ngOnInit() {
    this.alternatecompanyNames = this.companyDetails?.alternative_names?.length > 0 ? this.companyDetails.alternative_names.concat([this?.companyDetails?.name]): [this?.companyDetails?.name];
    this.companyDetails.latest_funding_stage = this.companyDetails?.latest_funding_stage?.replace(/_/g, ' ')
    this.getProfessionalCount();
    this.getMedianTanureCount();

    this.getGrowthRateAttrtionRateData();
  }

  getMedianTanureCount() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "total_tenure_median";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.medianTenureLoader = true;
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((res:any) => {
          this.medianTenureLoader = false;

      if(res.data && res.data.aggregations && res.data.aggregations.total_tenure_median){
        this.medianTanuresCount = res.data && res.data.aggregations && res.data.aggregations.total_tenure_median && res.data.aggregations.total_tenure_median.value;
      }
    });
  }

  getProfessionalCount() {
    let aggReq : AggregationRequest = new TIAggRequest();
    aggReq.aggregatetype = "location";
    aggReq.startindex = 0;
    aggReq.resultsize = 5;
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    aggReq = this.aggService.getRequestWithFilters();
    aggReq.companies = this.alternatecompanyNames;
    aggReq.companyids = [this.companyDetails.id];
    this.aggReqObjectHandlerService.setShareRequestObject(aggReq);
    this.companyInsightsService.getTotalCompanyaggs(aggReq).subscribe((res:any) => {
      this.totalresultscount = res.data.totalresultscount;
    });
  }

  getFormattedTenureForMatrix(tenure: number) {
    const totalYears = Math.floor(tenure);
    const totalMonths = Math.round((tenure - totalYears) * 12);
    if(tenure == null){
      return 0;
    }else if (totalYears > 0 && totalMonths > 0) {
      if(totalMonths == 12) {
        return `${totalYears + 1} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
      } else {
        return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()} ${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
      }
    } else if (totalYears > 0 && totalMonths == 0) {
      return `${totalYears} ${totalYears == 1 ? this.returnSpanTag('Yr').outerHTML.toString() : this.returnSpanTag('Yrs').outerHTML.toString()}`;
    } else if (totalYears == 0 && totalMonths > 0) {
      if(totalMonths == 12) {
        return `${totalYears + 1} ${this.returnSpanTag('Yr').outerHTML.toString()}`;
      } else
      return `${totalMonths} ${this.returnSpanTag('Mths').outerHTML.toString()}`;
    } else {
      return '';
    }
  }


returnSpanTag(text) {
  let spanTag = document.createElement("span");
  spanTag.className='median-tenure-text-size-compare';
  spanTag.innerHTML = text
  return spanTag;
}

getGrowthRateAttrtionRateData() {
  let request : AggregationRequest = new TIAggRequest();
  this.aggReqObjectHandlerService.setShareRequestObject(request);
  request = this.aggService.getRequestWithFilters();
  request.companyids = [this.companyDetails.id];
  request.companies = this.alternatecompanyNames;
  this.aggReqObjectHandlerService.setShareRequestObject(request);
  const data = {
    ...request,
    companies: this.alternatecompanyNames,

  };

  this.hiresAndAttritionObj = {};

  //Get company Attrition data
  this.recentAttritionLoader = true;
  this.recentHiresLoader = true;
  this.personSearchService.getCompanyAttrition(data).subscribe((res: any) => {
    this.recentAttritionLoader = false;
    if (res && res.data) {
      const recentAttrtion = {
        "increaseRate": res.data?.increaseRate,
        "previousYearCount": res.data?.previousYearCount,
        "currentYearCount": res.data?.currentYearCount,
        "type": res.data?.type
      }
      this.hiresAndAttritionObj['recentAttrtion'] = recentAttrtion
    }
  })

  //Get company Growth Data
  this.personSearchService.getCompanyGrowth(data).subscribe((res: any) => {
    this.recentHiresLoader = false;
    if (res && res.data) {
      const recentGrowth = {
        "increaseRate": res.data?.increaseRate,
        "previousYearCount": res.data?.previousYearCount,
        "currentYearCount": res.data?.currentYearCount,
        "type": res.data?.type
      }
      this.hiresAndAttritionObj['recentGrowth'] = recentGrowth;
    }
  })
}

scrollTOCompareCompany(companyDetails) {
  this.buttonClicked.emit(true);  // send 'true' to parent
  if (!this.companyInsightsService.companycompareone || this.companyInsightsService.companycompareone.length === 0) {
    this.companyInsightsService.companycompareone = [{ id: companyDetails.id, name: companyDetails.name, companylogo: companyDetails.companylogo ? companyDetails.companylogo: null }];
    this.localStorageService.setItem('companyOneId', companyDetails.id)
  } else if (!this.companyInsightsService.companycomparetwo || this.companyInsightsService.companycomparetwo.length === 0) {
    this.companyInsightsService.companycomparetwo = [{ id: companyDetails.id, name: companyDetails.name,companylogo: companyDetails.companylogo ? companyDetails.companylogo: null }];
    this.localStorageService.setItem('companyTwoId', companyDetails.id)

  } else {
    this.companyInsightsService.companycompareone = [{ id: companyDetails.id, name: companyDetails.name, companylogo: companyDetails.companylogo ? companyDetails.companylogo: null }];
    this.companyInsightsService.companycomparetwo = [];
    this.localStorageService.setItem('companyOneId', companyDetails.id)

  }

  const payload = {
    companyone: this.companyInsightsService.companycompareone,
    companytwo: this.companyInsightsService.companycomparetwo
  }


  this.companyInsightsService.sendCompanyCompareDetails(payload);
}

getDisabledCompareButton(companyId) {
  const companyOneId = this.localStorageService.getItem('companyOneId');
  const companyTwoId = this.localStorageService.getItem('companyTwoId');
  if(companyOneId && companyTwoId)
    return true;
  else if((companyOneId && companyOneId == companyId) && !companyTwoId)
    return true;
  else if(!companyOneId && (companyTwoId && companyTwoId == companyId))
    return true;
  else return false;
}

openUrl(link, type) {
  if (link.startsWith("www.linkedin") || link.startsWith("www.facebook") || link.startsWith("www.twitter") || link.startsWith("www.github"))
    link = "https://" + link;
  else if (type == 'linkedin' && !(link.includes("https://www.linkedin") || link.includes("https://linkedin") || link.includes("https://in.linkedin") || link.includes("http://linkedin") || link.includes("http://www.linkedin")))
    link = "https://www." + link;
  else if (type == 'facebook' && !(link.includes("https://www.facebook") || link.includes("https://facebook") || link.includes("https://in.facebook") || link.includes("http://facebook") || link.includes("http://www.facebook")))
    link = "https://www." + link;
  else if (type == 'twitter' && !(link.includes("https://www.twitter") || link.includes("https://twitter") || link.includes("https://in.twitter") || link.includes("http://twitter") || link.includes("http://www.twitter")))
    link = "https://www." + link;
  else if (type == 'github' && !(link.includes("https://www.github") || link.includes("https://github") || link.includes("https://in.github") || link.includes("http://github") || link.includes("http://www.github")))
    link = "https://www." + link;
  window.open(link, "_blank")
}

redirecttoCompanylist(company) {
  this.companyInsightsService.setCompanyListData(company);
  const companyinsightsFilter = this.filterDataHandlerService.fetchFilterData;
  this.localStorageService.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(companyinsightsFilter));
  const uniqueHash = this.hashService.generateUniqueHash();
  this.talentInsightsReqHandlerService.setSessionDataForCompanyInsightsRedirection(uniqueHash, companyinsightsFilter);
        /**
           * Company Insights viewed
           */
         const companyInsightsParams = {
          "User ID": this.localStorageService.getItem('userdata').userid,
          "Company name": company.name,
          "Source": "search",
          "Filters Applied": "none"

        }
        clevertap.event.push("Company Insights Viewed",companyInsightsParams);
        this.localStorageService.setItem('companyCurrency', 'USD')
  const data = {
    companies: [company.name],
    id: [company.id]
   }
  this.setCompanyInsightsHistory(data, 'company');
  const url = `/company-details/${company.id}?${GeneralConstants.LS_KEYS.UNIQUE_HASH_COMPANY}=${uniqueHash}`;
  window.open(url, "_blank");
}

setCompanyInsightsHistory(data, selectionType: string) {
  const payload = {
    ...((selectionType === 'company') && {
      companies: data.companies,
      companyids:
        data.id
    }),
    module: GlobalService.HISTORY_MODULE.COMPANY_COMPARISON
  }
  this.personSearchService.setInsightsHistory(payload).subscribe();
}

    formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K+', 'M+', 'B+', 'T+']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }


}
